import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'dashboard',
    component: Vue.component('dashboard', require('@/views/Main.vue').default)
  }, {
    path: '/Unauthorized',
    name: 'Unauthorized',
    component: Vue.component('Unauthorized', require('@/views/Unauthorized.vue').default)
  }, {
    path: '*',
    name: 'PageNotFound',
    component: Vue.component('PageNotFound', require('@/views/PageNotFound.vue').default)
  }],
});
